import Chart from './Chart.vue';
export default Chart;
